var map = {
	"./Dmart.png": 8512,
	"./Viatours.png": 9419,
	"./github.png": 3471,
	"./project-1.jpg": 9225,
	"./project-2.jpg": 5518,
	"./project-3.jpg": 299,
	"./project-4.jpg": 3976,
	"./project-5.jpg": 9989,
	"./project-6.jpg": 3738,
	"./todo_list.png": 9267,
	"./weekend_planner.png": 70
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 452;